// import { create } from "zustand";
// import { persist } from "zustand/middleware";
// import { immer } from "zustand/middleware/immer";

import { createStore } from "../../Boilerplate/NBoilerplateContext";
import { setGlobalStoreInstance } from "../../Boilerplate/store";

// App-specific slice
const createImportsSlice = (set, get) => ({
  imports: null,
  setImports: (imports) => set(() => ({ imports })),
  importsDomestic: null,
  setImportsDomestic: (importsDomestic) => set(() => ({ importsDomestic })),
  importsAsin: null,
  setImportsAsin: (importsAsin) => set(() => ({ importsAsin })),
});

export const store = createStore({ 
  name: "facetflux",
  appState: createImportsSlice
});

setGlobalStoreInstance(store); // Set it globally for non-React code

export const useStore = store;

// export const useStore = create(
//   persist(
//     immer((set, get) => ({
//       imports: null,
//       setImports: (imports) => set(() => ({ imports })),
//       importsDomestic: null,
//       setImportsDomestic: (importsDomestic) => set(() => ({ importsDomestic })),
//       importsAsin: null,
//       setImportsAsin: (importsAsin) => set(() => ({ importsAsin })),
//     }))
//   )
// );
